import type { NamedFieldProps } from "./Field.js";
import type { ImmutableMap, ValueCallback } from "shelving";
import { AllowStringSchema, OptionalSchema, getSource, getString, mapArray } from "shelving";
import { Field, useField } from "./Field.js";
import { FieldNotice } from "./FieldNotice.js";

export function RadiosField(props: NamedFieldProps): React.ReactElement {
	const field = useField<string | null>(props);
	const { name, form, schema, value } = field;
	const { allow } = getSource(AllowStringSchema, schema);
	return (
		<Field {...field}>
			<RadiosList //
				name={`${form.id}:${name}`}
				allow={allow}
				value={value}
				required={!(schema instanceof OptionalSchema)}
				onValue={v => form.publish(name, v)}
			/>
			<FieldNotice name={name} />
		</Field>
	);
}

export function RadiosList({
	name,
	mods = "flex-row flex-wrap gap-hairline",
	allow,
	placeholder = "None",
	required = false,
	value = null,
	onValue,
}: {
	name: string;
	mods?: string | undefined;
	allow: ImmutableMap<string, unknown>;
	placeholder?: string | undefined;
	required?: boolean | undefined;
	value?: string | null | undefined;
	onValue: ValueCallback<string | null>;
}): React.ReactElement {
	const onChange: React.FormEventHandler<HTMLInputElement> = ({ currentTarget }) => onValue(currentTarget.value);
	return (
		<div className={mods} role="radiogroup">
			{!required ? (
				<label className="input space-none">
					<input type="radio" name={name} defaultChecked={value === null} onChange={() => onValue(null)} />
					<span>{placeholder}</span>
				</label>
			) : null}
			{mapArray(allow, ([k, t]) => (
				<label key={k} className="input space-none">
					<input type="radio" name={name} defaultChecked={value === k} defaultValue={k} onChange={onChange} />
					<span>{getString(t)}</span>
				</label>
			))}
		</div>
	);
}
